<template>
    <div class="col-xl-3 xl-50 col-sm-6 box-col-6">
        <div class="card features-faq product-box">
            <div class="faq-image product-img"><img class="img-fluid" src="../../assets/images/faq/4.jpg" alt="">
                <div class="product-hover">
                    <ul>
                        <li><router-link to="/knowledgebase/detail"><i class="icon-link"></i></router-link></li>
                        <li><router-link to="/knowledgebase/detail"><i class="icon-import"></i></router-link></li>
                    </ul>
                </div>
            </div>
            <div class="card-body"><router-link to="/knowledgebase/detail">
                    <h6>Tailwind Design</h6>
                </router-link>
                <p>A Web Designing course belongs to the field of Computer Science and IT. It enables students to learn
                    various techniques.</p>
            </div>
            <div class="card-footer"><span>Apr 18, 2023</span>
                <ul class="pull-right">
                    <li><i class="fa fa-star font-primary"></i></li>
                    <li><i class="fa fa-star font-primary"></i></li>
                    <li><i class="fa fa-star font-primary"></i></li>
                    <li><i class="fa fa-star font-primary"></i></li>
                    <li><i class="fa fa-star-half-o font-primary"></i></li>
                </ul>
            </div>
        </div>
    </div>
</template>